export default "__VITE_ASSET__vbd5fJ70__"